import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, Icon, Optional } from '@honda-canada/design-system-react';
import kebabCase from 'lodash/kebabCase';
import { compiler } from 'markdown-to-jsx';
import themeStyles from './styles/InventoryFiltersSectionItem.styles';
const Label = themeStyles.apply(Button, 'Label');
const HiddenInput = themeStyles.apply('input', 'HiddenInput');
const CheckmarkIcon = themeStyles.apply(Icon, 'CheckmarkIcon');
const InventoryFiltersSectionItem = ({ item }) => {
    const { label, key, selected, disabled, handleClick } = item;
    const formatLabelTestId = kebabCase(label);
    const tabIndexValue = disabled ? -1 : 0;
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.code === 'Space') {
            e.preventDefault(); // Stop page scrolling with spacebar when using it on this component
            handleClick(selected, key);
        }
    };
    return (_jsxs(Label, { as: "label", htmlFor: key, active: selected, tabIndex: tabIndexValue, "data-testid": `cy-${formatLabelTestId}-tag`, disabled: disabled, onKeyDown: (e) => handleKeyDown(e), children: [_jsx(HiddenInput, { type: "checkbox", id: key, checked: selected, disabled: disabled, onChange: () => handleClick(selected, key) }), _jsx(Optional, { when: selected, children: _jsx(CheckmarkIcon, { iconColor: "white", name: "checkmark" }) }), compiler(label)] }));
};
export default InventoryFiltersSectionItem;
